
import { TOKEN_API, SERVICES_API } from "../config/api";

class AuthService {

    // Get Authorization Token ====================================================================================================

    /**
     * Get Authorization Token
     * @type {object}
     * @property {string} grant_type
     * @property {string} client_id
     * @property {string} client_secret
     * @property {string} scope
     * @returns {object} - The Authorization Token
    */
    getAuth() {
        const url = `/oauth/token`;
        const data = {
            grant_type: "client_credentials",
            client_id: process.env.REACT_APP_CLIENT_ID,
            client_secret: process.env.REACT_APP_CLIENT_SECRET,
            scope: ""
        }

        return TOKEN_API.post(url, data);
    }

    // Log In the user ====================================================================================================

    /**
     * Log in the user
     * @type {object}
     * @property {number} canal
     * @property {string} idSesion
     * @property {string} ipAddress
     * @property {number} loginCliente
     * @property {string} nombreServer
     * @property {string} passwordCliente
     * @property {number} oficina
     * @property {string} password
     * @property {number} terminal
     * @property {string} usuario
     * @returns {object} - The user info
    */
    login(data) {
        const url = `/login`;

        return SERVICES_API.post(url, data);
    }


    // Logs out the user ====================================================================================================

    /**
     * Logs out the user
     * @type {object}
     * @property {number} loginCliente
     * @property {number} ntv
     * @returns {object} - True/false if the user was logged out
    */
    logout(data) {
        const url = `/logout`;

        return SERVICES_API.post(url, data);
    }

    
    // Encrypt the user's password ====================================================================================================

    /**
     * Encrypts the user's password
     * @type {object}
     * @property {string} password
     * @returns {object} - The encypted password
    */
    encryptPassword(data) {
        const url = `/encryptPassword`;

        return SERVICES_API.post(url, data);
    }
    
}

export default new AuthService();